import {Component, EventEmitter, Input, Output} from '@angular/core';

@Component({
  selector: 'core-file-widget',
  imports: [],
  standalone: true,
  templateUrl: './file-widget.html',
  styleUrl: './file-widget.scss',
  host: {
    style: 'padding: 0.5rem 0.75rem;display: flex;flex-direction: row;width: 100%;border-radius:0.5rem;gap: 1.5rem;align-self: start;height: fit-content;',
    class: 'bg-neutral'
  }
})
export class FileWidget {
  @Input() fileName: string = 'Nombre del archivo.doc';
  @Input() fileSize: string = '0 KB';
  @Input() badge: string = '';
  @Input() showActions: boolean = true;
  @Input() showDownload: boolean = true;
  @Input() showRemove: boolean = true;
  @Output() remove = new EventEmitter<void>();
  @Output() download = new EventEmitter<void>();

}
